import { render } from "./CheckboxMultiInput.vue?vue&type=template&id=22a2b04b"
import script from "./CheckboxMultiInput.vue?vue&type=script&lang=js"
export * from "./CheckboxMultiInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__